import React, { Component, useLayoutEffect } from "react";
import {
  BrowserRouter as Enrutador,
  Routes,
  Route,
  Switch,
  Navigate,
} from "react-router-dom";
import Home from "../pages/Home";
import Sobre from "../pages/Sobre";
import Gallery from "../pages/Gallery";
import Layout from "../layouts/Layout";
import Itinerario from "../pages/Itinerario";
import Contact from "../pages/Contact";
import FormularioReserva from "./FormularioReserva/FormularioReserva";
import Pagar from "./Pagar/Pagar";
import ListadoEventos from "./ListadoEventos/ListadoEventos";
import SeleccionDeMesas from "./SeleccionDeMesas/SeleccionDeMesas";
import Finalizacion from "./Finalizacion/Finalizacion";
import Error from "./Finalizacion/Error";
import Succes from "./Finalizacion/Success";
import Login from "./auth/login/Login";
import Register from "./auth/register/Register";
import Gestiones from "../pages/Gestiones";
import ListadoOpcionales from "./ListadoOpcionales/ListadoOpcionales";
import AuthCallback from "./auth/callback/GoogleCallback";
import FacebookCallback from "./auth/callback/FacebookCallback";
import Auth from "./auth/page/Auth";
import { AuthProvider } from "../context/AuthContext";
import PrivateRoute from "./auth/private/PrivateRoute";
import Profile from "./auth/profile/page/Profile";
import PublicRoute from "./auth/public/PublicRoute";
import { ProductProvider } from "../context/ProductContext";
import PoliticaPrivacidad from "../pages/PoliticaPrivacidad";
import EliminarUser from "../pages/EliminarUser";

class Router extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reserva: {
        idEntidad: 0,
        totalReserva: 0,
        tarifaBaseAdulto: 0,
        tarifaBaseMenor: 0,
        paxTotales: 0,
        paxAdultos: "",
        paxMenores: "",
        observacion: "",
        direccion: "",
        idTipoDocumento: 1,
        numeroDocumento: "",
        idEvento: 0,
        titular: "",
        email: "",
        telefono: "",
        evento: { fecha: "" },
        mesas: [],
        sillas: [],
      },
      evento: {
        cantidad: 0,
        reservasTotalPax: 0,
        productoM: {
          tarifasM: {
            tarifaAdulto: 0,
            tarifaMenor: 0,
          },
        },
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    //this.handleInputTarifasChange = this.handleInputTarifasChange.bind(this);
    this.handleEvento = this.handleEvento.bind(this);
    this.handleResetearPersonas = this.handleResetearPersonas.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChairChange = this.handleChairChange.bind(this);
  }

  handleEvento(evento) {
    //let evento = Object.assign({}, this.state.reserva);
    this.setState({ evento });
  }

  handleInputChange(name, value) {
    //this.props.onInputsChange(e.target.name, e.target.value);

    let reserva = Object.assign({}, this.state.reserva);
    //reserva.titular = e.target.value;
    reserva[name] = value;
    this.setState({ reserva: reserva });
  }

  handleTableChange(value) {
    //this.props.onInputsChange(e.target.name, e.target.value);

    let reserva = Object.assign({}, this.state.reserva);
    //reserva.titular = e.target.value;
    reserva.mesas = value;
    this.setState({ reserva: reserva });
  }

  handleChairChange(value) {
    //this.props.onInputsChange(e.target.name, e.target.value);
    let reserva = Object.assign({}, this.state.reserva);
    //reserva.titular = e.target.value;
    reserva.sillas = value;
    this.setState({ reserva: reserva });
  }

  handleResetearPersonas() {
    let reserva = Object.assign({}, this.state.reserva);
    reserva.paxAdultos = 0;
    reserva.paxMenores = 0;

    this.setState({ reserva: reserva });
  }

  calcularTotal() {
    return (
      Number(this.state.evento.productoM.tarifasM.tarifaAdulto) *
      this.state.reserva.paxAdultos +
      Number(this.state.evento.productoM.tarifasM.tarifaMenor) *
      this.state.reserva.paxMenores
    ).toFixed(2);
  }

  calcularTotalPax() {
    return (
      Number(this.state.reserva.paxAdultos) +
      Number(this.state.reserva.paxMenores)
    );
  }

  render() {
    const FormularioReservaConProps = (props) => {
      return (
        <FormularioReserva
          
        />
      );
    };

    const PagarConProps = (props) => {
      return (
        <Pagar
          {...props}
          reserva={this.state.reserva}
          totalReserva={this.calcularTotal()}
          totalPax={this.calcularTotalPax()}
          evento={this.state.evento}
        />
      );
    };

    const MapaMesas = (props) => {
      return (
        <SeleccionDeMesas
          {...props}
          reserva={this.state.reserva}
          totalReserva={this.calcularTotal()}
          totalPax={this.calcularTotalPax()}
          evento={this.state.evento}
          onHandleTableChange={this.handleTableChange}
          onHandleChairChange={this.handleChairChange}
        />
      );
    };

    const ListadoEventosConProps = (props) => {
      return <ListadoEventos {...props} onEventoClick={this.handleEvento} />;
    };

    return (
      <>
        <Enrutador>
          <AuthProvider>
            <ProductProvider>
              <Routes>
                <Route exact path="/" element={<Layout />}>
                  <Route index element={<Home />}></Route>
                  <Route path="/politicasyprivacidad/" element={<PoliticaPrivacidad />}></Route>
                   <Route path="/eliminar-user/" element={<EliminarUser />}></Route>
                  <Route path="/sobre/" element={<Sobre />}></Route>
                  <Route path="/gallery" element={<Gallery />}></Route>
                  <Route path="/itinerario" element={<Itinerario />}></Route>
                  <Route path="/contacto" element={<Contact />}></Route>
                  <Route path="/reserva/" element={<ListadoEventos />}></Route>
                  {/* <Route path="/opcionales/" element={<ListadoOpcionales/>}></Route> */}
                  <Route path="/formulario/:idEvento" element={<FormularioReserva />}></Route>
                  <Route path="/reserva/modoPago" element={<PagarConProps />}></Route>
                   <Route  path="/finalizacion/:idReserva/:estado" element={<Finalizacion />}></Route>
                  <Route path="/gestiones" element={<Gestiones />}></Route>
                  <Route path="/auth" element={<Navigate to="/auth/login" />} />
                  <Route path="/auth/login" element={<PublicRoute>{" "}<Login />{" "}</PublicRoute>}></Route>
                  <Route
                    path="/auth/register"
                    element={
                      <PublicRoute>
                        <Register />
                      </PublicRoute>
                    }
                  ></Route>
                  <Route
                    path="/auth/callback/google"
                    element={<AuthCallback />}
                  ></Route>
                  <Route
                    path="/auth/callback/facebook"
                    element={<FacebookCallback />}
                  ></Route>
                  <Route
                    path="/auth/profile"
                    element={
                      <PrivateRoute>
                        <Profile />
                      </PrivateRoute>
                    }
                  ></Route>

                  <Route path="*" element={<Home />}></Route>
                </Route>
              </Routes>
            </ProductProvider>
          </AuthProvider>
        </Enrutador>
      </>
    );
  }
}

export default Router;
